<template>
  <div class="gt-timeline">
    <el-timeline v-if="logList.length > 0">
      <el-timeline-item
        v-for="(item, index) in list"
        :key="index"
        type="primary"
        size="normal"
        color="#0B69FF"
        :class="[hasNone ? 'none' : '']"
      >
        <div class="gt-timeline__log-content">
          <div class="left">
            <div class="name">{{ item.user }}</div>
            <div class="left-log">
              <span class="oplog"> {{ item.opLog }}</span>
              <span class="changestatus"> {{ item.statusChange }}</span>
            </div>
          </div>
          <div class="time">{{ item.time }}</div>
        </div>
      </el-timeline-item>
      <el-timeline-item
        :icon="icon"
        size="normal"
        :class="['btn', hasNone ? 'none' : '']"
      >
        <el-button
          type="text"
          size="medium"
          @click="handleViewMore"
          :disabled="!canClick"
        >
          {{ isMore ? hasMoreText : noMoreText }}
        </el-button>
      </el-timeline-item>
    </el-timeline>
    <div v-else class="gt-timeline__nodata">
      {{ noDataText }}
    </div>
  </div>
</template>
<script>
export default {
  name: "TimeLine",

  data() {
    return {
      list: [],
      logs: [],
      canClick: true,
      isMore: true,
      hasNone: true
    };
  },

  props: {
    logList: {
      type: Array,
      default: () => []
    },
    defaultNumber: {
      type: Number,
      default: 3
    },
    hasMoreText: {
      type: String,
      default() {
        return this.$t("Root.TimeLine.View_More");
      }
    },
    noMoreText: {
      type: String,
      default() {
        return this.$t("Root.TimeLine.Callpase");
      }
    },
    noDataText: {
      type: String,
      default() {
        return this.$t("Root.TimeLine.No_Data");
      }
    }
  },

  watch: {
    logList: {
      handler: "init",
      immediate: true
    }
  },

  computed: {
    icon: {
      set() {
        return (this.icon = "el-icon-arrow-down");
      },
      get() {
        return this.isMore ? "el-icon-arrow-down" : "el-icon-arrow-up";
      }
    }
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.logs = this.logList.map(item => {
        return {
          ...item,
          opLog: item.opLog || this.$t("Root.TimeLine.OperationLog")
        };
      });

      const {
        logs,
        logs: { length },
        defaultNumber: maxLength
      } = this;

      if (length == 0) {
        this.canClick = false;
      } else if (length <= maxLength) {
        this.list = logs.slice(0, maxLength);
        this.canClick = false;
        this.hasNone = true;
      } else {
        this.canClick = true;
        this.hasNone = false;
        this.list = logs.slice(0, maxLength);
      }
    },

    handleViewMore() {
      if (!this.canClick) return;

      this.list = this.isMore
        ? this.logs.slice(0)
        : this.logs.slice(0, this.defaultNumber);

      this.isMore = !this.isMore;
    }
  }
};
</script>
<style lang="scss">
.gt-timeline {
  padding: 28px 20px 0 20px;
  background: #fff;
  border: $--table-border;
  &__nodata {
    text-align: center;
  }
  &__log-content {
    display: flex;
    justify-content: space-between;
    .time {
      padding-left: 15px;
      color: rgba(0, 0, 0, 0.45);
      min-width: 135px;
    }
    .left {
      &-log {
      }
      .name {
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 20px;
      }
      .oplog {
        display: inline-block;
        line-height: 100%;
        border-radius: 2px;
        padding: 0px 4px 2px 4px;
        color: rgba(51, 136, 255, 1);
        background-color: #e6f4ff;
      }
      .changestatus {
        font-weight: 400;
        color: rgba(0, 0, 0, 0.6);
        line-height: 20px;
      }
    }
  }
  .el-timeline-item__node--normal {
    width: 7px;
    height: 7px;
  }
  .el-timeline-item__wrapper {
    top: -8px;
  }
  .el-timeline-item.btn {
    padding-bottom: 0;
    .el-timeline-item__node-- {
      width: 24px;
      height: 24px;
      background-color: transparent;

      .el-timeline-item__icon {
        color: #0b69ff;
        margin: -18px 0 0 -17px;
      }
    }

    .el-timeline-item__wrapper {
      top: -16px !important;
    }
    &.none {
      display: none;
    }
  }

  .el-timeline-item__tail {
    left: 2px;
    top: 12px;
    height: 80%;
    border-left: 1px solid #e3e6eb;
  }

  .el-timeline-item:nth-last-child(2).none {
    .el-timeline-item__tail {
      border: none;
    }
  }
}
</style>
